<template>
    <div class="row justify-content-center">
        <div class="col-md-8">        
            <div>
                <fieldset :disabled="loading">
                    <div class="roundbox">
                        <div class="rbcontent">
                            <a :href=imgLogoUrlPath target="_blank" title="İzOnay"><img :src="imgLogoPath" class="float-right"/></a>
                            <h2>E-İmzalı Döküman Doğrulama</h2>
                            <form @submit.prevent="validate" class="search-form">
                                <fieldset>
                                    <div class="form-group">
                                        <label>Döküman Doğrulama Kodu</label>
                                        <input ref="ValidationCode" v-model="data.Code" type="text" @blur="refreshCaptcha()" class="form-control" aria-describedby="accountHelp" required />
                                    </div> 
                                    <div class="form-group">
                                        <label>Güvenlik Kodu</label>
                                        <div class="input-group input-group-lg">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text captcha" title="Güvenlik kodunu yenilemek için tıklayın" ref="captcha" @click="focusValidationCodeOrRefreshCaptcha()"></span>
                                            </div>
                                            <input v-model="data.Captcha" type="text" placeholder="Yandaki güvenlik kodunu giriniz" class="form-control" aria-describedby="captchaHelpBlock" required />
                                            <small id="captchaHelpBlock" class="form-text text-muted">
                                                Lütfen resimde gördüğünüz karakterleri yanında bulunan kutuya giriniz. Resmi okuyamıyorsanız, üzerine tıklayarak yeni bir tane oluşturabilirsiniz.
                                            </small>
                                        </div>
                                    </div>
                                    <div v-if="loading" class="loader-container">
                                        <MikepadLoader />
                                        <p>Doküman Hazırlanıyor Lütfen Bekleyiniz. <br>
                                        Bu işlemin tamamlanması bir dakikayı bulabilir.</p>
                                    </div>
                                    <div class="form-group text-center">
                                        <button type="submit" class="btn btn-primary btn-lg btn-block">Doğrula</button>
                                    </div>
                                    <div v-if="errorMessage" class="text-danger">Hata: {{errorMessage}}</div>
                                </fieldset>
                            </form> 
                        </div>
                    </div>

                    <div class="roundbox" v-show="validationResult">
                        <div class="rbcontent">
                            <h2>Doğrulama Sonucu</h2>
                            <div class="row data-container" >
                                <div class="approval-div">
                                    <span><span class="title">Takip Numarası: </span> {{validationResult.TranckingNumber}}</span>                                
                                    <!-- <span><span class="title"> İşin Adı:</span> {{validationResult.JobName}}</span> -->                                
                                    <span> <span class="title"> Geçerli Mi:</span> {{validationResult.IsValid ? "Evet": "Hayır"}}</span>
                                    <br>
                                    <span>
                                        <span class="title" style="text-decoration: underline;">İmzalayan Kullanıcılar</span>
                                            <ul v-for="signer in validationResult.Signers" :key="signer.OwnerName">
                                                <li class="signer-info" >
                                                    <div>{{signer.OwnerName}}</div>
                                                    <div>{{signer.SignatureType}}</div>
                                                    <div v-if="signer.SigningTime">{{signer.SigningTime | datetime}} {{getSignatureTimeType(signer.SignatureType)}}</div>
                                                </li>
                                            </ul>
                                    </span>
                                    </div>
                                <div class="col text-right">
                                    <div v-if="pdfURL">
                                    <pdfViewer :pdfurl="pdfURL" ref="pdfComponent"/>
                                    </div>
                                    <div v-if="showDocumentLoading" class="show-document-container">
                                        <div class="mikepad-container">
                                            <MikepadLoader /> 
                                        </div>
                                        <p> Doküman Hazırlanıyor Lütfen Bekleyiniz. </p>
                                    </div>
                                    <button type="button" class="btn btn-primary" style="margin-right: 12px" v-show="isViewable" :disabled="showDocumentLoading" @click="showDocument(true)"> Görüntüle </button>
                                    <button type="button" class="btn btn-success" style="margin-right: 12px" v-show="isDownloadable" :disabled="showDocumentLoading" @click="showDocument(false)"> İndir </button>
                                </div>
                            </div>                            
                        </div>
                    </div>                    
                </fieldset>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import formMixin from '../formMixin.js'; 
import pdfViewer from '../components/PDFJSViewer.vue'
import MikepadLoader from '../components/MikepadLoader.vue'

export default {
    mixins: [formMixin],
    components: {
        pdfViewer,
        MikepadLoader
    },
    created(){
        if(this.$route.params != undefined && this.$route.params!= "" && this.$route.params.code != undefined&& this.$route.params.code != "" )
        this.data.Code = this.$route.params.code;
        console.log(this.$route.params.code);           
    },
    mounted(){
        this.focusValidationCodeOrRefreshCaptcha();
    },
    data(){
        return { 
            pdfURL: null,
            completed:false,
            loading: false,
            showDocumentLoading: false,
            data: {Code:'' },
            code:'',
            errorMessage: '',
            validationResult: '',
            isViewable : false,
            isDownloadable : false
        };
    },
    computed: {
        imgLogoPath() {
        return window.settings.customization?.imgLogo == null ? require("../assets/logo.png") : "../img/" + window.settings.customization.imgLogo;
        },
        imgLogoUrlPath(){
            return window.settings.customization?.imgLogoURL == null ? "https://www.izonay.com/" : window.settings.customization.imgLogoURL;
        }
  },
methods: {
    refreshCaptcha(){
        return axios.get('/validate/captcha?code='+this.data.Code)
        .then(x => {
            this.$refs.captcha.style = `background-image: url('data:image/jpg;base64,${x.data.Data.base64image}')`;
            this.data.Identifier = x.data.Data.identifier;
            this.data.Captcha = '';
        })
        .catch(x => {
            this.$refs.captcha.style = "background-color:#e9ecef;";
            this.data.Identifier = null;
            this.data.Captcha = '';
            console.warn('CAPTCHA yüklenemedi: ', x);
        })
    },    
    getSignatureTimeType(signatureType){
        if(signatureType == "Basit İmza")
            return "";
        return "(Zaman Damgası Tarihi)"
    },
    validate(){
        console.log(this.data);
        this.loading = true;
        axios.post('/validate/post', this.data)
        .then(x => {
            this.errorMessage = null;
            console.log("Gelen sonuç:", x);
            if(x.data.Success) {
                this.validationResult = x.data.Data;
                this.completed = true;
                this.isViewable = this.validationResult.isViewable;
                this.isDownloadable = this.validationResult.isDownloadable;
                this.refreshCaptcha().then(() => {
                    this.loading = false;
                });
                this.data.Captcha = '';
            } else {
                this.validationResult ="";
                this.errorMessage = x.data.ErrorMessages;
                this.refreshCaptcha().then(() => {
                    this.loading = false;
                });
            }
        }).catch(e => {
            console.log('Error:', e);
            if(e.response === undefined) {
                this.errorMessage = "Erişim sağlanamadı. Lütfen internet bağlantınızı kontrol edin.";
            } else {
                this.errorMessage = "Beklenmeyen bir hata oluştu. Lütfen bir süre sonra tekrar deneyin";
            }

            this.refreshCaptcha().then(() => {
                this.loading = false;
            });
        })

        
    } ,
    downloadDocument(document, isSigned = false){
        // İndirilecek doküman için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
        return axios
            .post(`/jobDocumentUrl/`, {
                EntityId : this.data.Id,
                DocumentId: document.Id,
                IsSigned: isSigned
            })
            .then(x => {
            console.log("jobDocumentUrl Result:", x.data);
            window.open(x.data.Data.Url);
            })
            .catch(x => window.processErrorResponse(x, this));
    },

    focusValidationCodeOrRefreshCaptcha()
    {
        if(!this.data.Code)
        {
            this.$refs.ValidationCode.focus();
        }
        else
            this.refreshCaptcha();
    },
    getDocumentDownloadUrl(){
        return axios.post('/document/post' ,  this.data)
        .then(x => {
            console.log("createDocumentUrl Result:", x.data);
            
          
                this.pdfURL = x.data.Data.Url + "&view=false" ;
            
                
                  
        })
        .catch(x => window.processErrorResponse(x, this));
    },
    showDocument(isShow){
        this.showDocumentLoading = true;
        this.getDocumentDownloadUrl().then(() => {
            this.showDocumentLoading = false;
            console.log(this.pdfURL);
            if(isShow)
            {
                
                
                this.$refs.pdfComponent.show();
            }
            else
            {
                window.open(this.pdfURL);
            }
            this.refreshCaptcha().then(() => {
                this.loading = false;
            });
        })
       
    }     
}
}
</script>
<style scoped>
    ul{
        list-style-image: url('../assets/green-check.png') !important;
        list-style-type: square ;
    }
    .show-document-container{
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-end;
    }
    .mikepad-container{
        margin-right: 100px;
        margin-bottom: 10px;
    }
    .loader-container{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .loader-container p{
        margin-top: 10px;
        margin-bottom: 10px;
    }
.captcha {
    width:100px;
    background-repeat: no-repeat;
    background-position: center center;
    cursor: pointer;
}
.search-form{
        padding: 20px 40px 30px 40px;
    /* background: white; */
    margin-bottom: 10px;
    margin: 0 auto;
    /* padding: 0 20px; */
    /* max-width: 500px; */
    border-top: 0;
    box-shadow: 0 0 0;
    border-radius: 16px;
    background-color: #fff;
    
    margin-bottom: 30px;
}
.data-container{
      padding: 20px 40px 30px 40px;
    /* background: white; */
    margin-bottom: 10px;
    margin: 0 auto;
    /* padding: 0 20px; */
    /* max-width: 500px; */
    border-top: 0;
    box-shadow: 0 0 0;
    border-radius: 16px;
    background-color: #fff;
    display: grid;
    margin-bottom: 30px;
}
.btn-validate{
    margin-top: 0;
    width: 25%;
    font-size: 15px;
    line-height: 1.3333333;
    text-transform: capitalize;
    border-radius: 8px;
    background: #08b7cd !important;
    padding: 10px;
    border-color: #08b7cd !important;
    float: right;
}
.title{
    font-weight: 700;
    font-size: 14px;
    color: #888181;
} 
.signer-info{
    margin-top: 10px;
    line-height:25.3px;
}


.approval-div{
    display: flex;
    text-align: left;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
}
</style>